module.exports = __webpack_public_path__ + "static/media/UC_san_diego.c27b831b.png";